// src/i18n/translations.js
export const translations = {
  en: {
    title: "Veyra Prints",
    settings: "Settings",
    save: "Save",
    next: "Next",
    return: "Return to Canvas",
    selectLanguage: "Select Language",

    // Sidebar
    photoTab: "PHOTO",
    layoutTab: "LAYOUT",
    themesTab: "THEMES",
    addPhotos: "ADD PHOTOS",
    autofill: "AUTOFILL",
    sortByOrder: "Sort by order added to project",
    hideUsed: "Hide Used",
    search: "Search",
  },
  fr: {
    title: "Toile de produit photo",
    settings: "Paramètres",
    save: "Enregistrer",
    next: "Suivant",
    return: "Retour à la toile",
    selectLanguage: "Choisir la langue",

    // Sidebar
    photoTab: "PHOTO",
    layoutTab: "DISPOSITION",
    themesTab: "THÈMES",
    addPhotos: "AJOUTER DES PHOTOS",
    autofill: "REMPLIR AUTOMATIQUEMENT",
    sortByOrder: "Trier par ordre d’ajout au projet",
    hideUsed: "Masquer les utilisés",
    search: "Recherche",
  },
  da: {
    title: "Fotoproduktlærred",
    settings: "Indstillinger",
    save: "Gem",
    next: "Næste",
    return: "Tilbage til lærredet",
    selectLanguage: "Vælg sprog",

    // Sidebar
    photoTab: "FOTO",
    layoutTab: "LAYOUT",
    themesTab: "TEMAER",
    addPhotos: "TILFØJ BILLEDER",
    autofill: "AUTOFYL",
    sortByOrder: "Sorter efter rækkefølge tilføjet til projektet",
    hideUsed: "Skjul brugte",
    search: "Søg",
  },
  hr: {
    title: "Platno za foto proizvode",
    settings: "Postavke",
    save: "Spremi",
    next: "Sljedeće",
    return: "Povratak na platno",
    selectLanguage: "Odaberi jezik",

    // Sidebar
    photoTab: "FOTOGRAFIJA",
    layoutTab: "IZGLED",
    themesTab: "TEME",
    addPhotos: "DODAJ FOTOGRAFIJE",
    autofill: "AUTOPOPUNI",
    sortByOrder: "Sortiraj po redoslijedu dodavanja u projekt",
    hideUsed: "Sakrij korištene",
    search: "Pretraga",
  },
};
